import { AddressAutocompleteItem } from '@/models/address.model';
import { HereAutocompleteItem } from '@/proxy/dtos/hereAutocompleteItem';

export const toAddressAutocompleteItem = (data: HereAutocompleteItem): AddressAutocompleteItem => ({
  title: data.title,
  id: data.id,
  label: data.address?.label,
  countryCode: data.address?.countryCode,
  countryName: data.address?.countryName,
  stateCode: data.address?.stateCode,
  state: data.address?.state,
  city: data.address?.city,
  district: data.address?.district,
  street: data.address?.street,
  postalCode: data.address?.postalCode,
  houseNumber: data.address?.houseNumber,
});
